// this method is called as callback by Google Maps Javascript API (see src attribute @ <script> include)
window.googleMapsOnLoad = function () {
  Map.init();
};

var Map = {
  map: null,
  map_large: null,
  overlays: [],
  overlays_large: [],

  // set the options for the Google Maps initial display
  mapOptions: {
    zoom: 6,
    center: {lat: 52.373169, lng: 4.890660}, // default zoom and lat/lng for Netherlands
    disableDefaultUI: true,
    mapTypeId: 'roadmap',
    // styling theme "ultra light with labels" taken from: https://snazzymaps.com/style/151/ultra-light-with-labels
    // styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]

    // styling theme "silver" taken from: https://mapstyle.withgoogle.com/
    styles: [{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}]
  },

  init: function () {
    var $googleMapsContainer = $('.google-maps--container');
    if ($googleMapsContainer.length > 0) {
      // render the map and add it to the DOM
      Map.map = new google.maps.Map($googleMapsContainer[0], Map.mapOptions);

      Map.initSelectedPaperOverlays();

      Map.bindEvents();
    }
  },

  bindEvents: function() {
    $(document).on('click', '.google-maps--controls .icon--plus', function() {
      Map.zoomIn($(this));
    });

    $(document).on('click', '.google-maps--controls .icon--min', function() {
      Map.zoomOut($(this));
    });

    $(document).on('click', '.google-maps--controls .icon--full-screen', function() {
      Map.doFullScreen();
    });

    var mapIsMoving = false;
    $(document).on('click', '.mobile-map-trigger', function() {
      if ( ! mapIsMoving) {
        var $aside = $('aside');
        $aside.toggleClass('is-open');
      }
    });
  },

  makeLatLngsFromArray: function (a) {
    if(!a) {
      return [];
    }

    var res = [];
    for (var i = 0; i < a.length; i++) {
      res[i] = new google.maps.LatLng(a[i][0], a[i][1])
    }
    return res;
  },

  addOverlay: function(id, shape) {
    // check if this overlay is already present
    for(var i = 0; i < Map.overlays.length; i += 1) {
      if (Map.overlays[i].id === id) {
        return;
      }
    }

    var latlngs = Map.makeLatLngsFromArray(shape);

    var polygon = new google.maps.Polygon({
      map: Map.map,
      clickable: false,
      paths: latlngs,
      strokeColor: main_color,
      strokeOpacity: 1,
      strokeWeight: 2,
      fillColor: main_color,
      fillOpacity: '0.5'
    });

    Map.overlays.push({'id': id, 'polygon': polygon});

    Map.fitAllOverlays(Map.map, Map.overlays);
  },

  removeOverlay: function(id) {
    for(var i = 0; i < Map.overlays.length; i += 1) {
      if (Map.overlays[i].id === id) {
        var overlay = Map.overlays[i];

        if (overlay !== undefined) {
          overlay.polygon.setMap(null);
        }

        Map.overlays.splice(i, 1);
      }
    }

    if (Map.overlays.length > 0) {
      Map.fitAllOverlays(Map.map, Map.overlays);
    }
  },

  setLoading: function() {
    $('.google-maps--loader').addClass('loading');
  },

  unsetLoading: function() {
    $('.google-maps--loader').removeClass('loading')
  },

  zoomIn: function($that) {
    Map.handleZoom($that, 1);
  },

  zoomOut: function($that) {
    Map.handleZoom($that, -1);
  },

  handleZoom: function($that, step) {
    var useMap = Map.map;
    if ($that.closest('.modal-maps').length > 0) {
      useMap = Map.map_large;
    } else if ($that.closest('.maps-stats-placeholder').length > 0) {
      useMap = MapInfoPopup.map;
    }

    var currentZoom = useMap.getZoom();
    var newZoom = currentZoom + step;
    useMap.setZoom(newZoom);
  },

  initSelectedPaperOverlays: function() {
    var $selectedContainer = $('.search-results--type-selected');
    if ($selectedContainer.length > 0) {
      $selectedContainer.find('.search-result--newspaper').each(function() {
        var latlngs = Map.makeLatLngsFromArray($(this).data('shape'));

        var polygon = new google.maps.Polygon({
          map: Map.map,
          clickable: false,
          paths: latlngs,
          strokeColor: main_color,
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: main_color,
          fillOpacity: '0.5'
        });

        Map.overlays.push({'id': $(this).val(), 'polygon': polygon});
      });

      if (Map.overlays.length > 0) {
        Map.fitAllOverlays(Map.map, Map.overlays);
      }
    }
  },

  fitAllOverlays: function(useMap, useOverlays) {
    var bounds = new google.maps.LatLngBounds();

    useOverlays.forEach(function (overlay) {
      if (overlay.polygon.getPath() !== undefined) {
        overlay.polygon.getPath().forEach(function (element, index) {
          bounds.extend(element)
        });
      }
    });

    useMap.fitBounds(bounds);
  },

  doFullScreen: function() {
    $('.modal-content-placeholder').html('<div class="modal-maps modal-content">' +
      '                    <div class="google-maps--controls google-maps--controls--left">\n' +
      '                        <div class="icon icon--plus">+</div>\n' +
      '                        <div class="icon icon--min">-</div>\n' +
      '                    </div>\n<div id="maps_large"></div></div>');

    $('.modal-maps').width(600).height(600);

    // render the map and add it to the DOM
    Map.map_large = new google.maps.Map($('#maps_large')[0], Map.mapOptions);

    if (Map.overlays.length > 0) {
      Map.overlays_large = [];
      Map.overlays.forEach(function (overlay) {
        var path = overlay.polygon.getPath();
        var polygon = new google.maps.Polygon({
          map: Map.map_large,
          clickable: false,
          paths: path,
          strokeColor: main_color,
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: main_color,
          fillOpacity: '0.5'
        });

        Map.overlays_large.push({polygon: polygon});
      });

      if (Map.overlays_large.length > 0) {
        Map.fitAllOverlays(Map.map_large, Map.overlays_large);
      }
    } else {
      Map.map_large.setZoom(7);
    }

    Modal.showModal();
  },
};

export default Map;
